import { render, staticRenderFns } from "./merchant-crop.vue?vue&type=template&id=ae4a26ae&scoped=true"
import script from "./merchant-crop.vue?vue&type=script&lang=js"
export * from "./merchant-crop.vue?vue&type=script&lang=js"
import style0 from "./merchant-crop.vue?vue&type=style&index=0&id=ae4a26ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4a26ae",
  null
  
)

export default component.exports